export const HOUR_HEIGHT = 72; // px per hour
export const PX_PER_MIN = HOUR_HEIGHT / 60;
export const SNAP = 15; // minutes

export function pad(n) { return String(n).padStart(2, "0"); }

export function minutesToLabel(mins, format = "12") {
  let m = ((mins % 1440) + 1440) % 1440;
  const h = Math.floor(m / 60);
  const mm = m % 60;
  if (format === "24") return `${pad(h)}:${pad(mm)}`;
  const period = h >= 12 ? "PM" : "AM";
  let hh = h % 12;
  if (hh === 0) hh = 12;
  return `${hh}:${pad(mm)} ${period}`;
}

export function hourLabel(h, format = "12") {
  return minutesToLabel(h * 60, format);
}

export function formatDuration(mins) {
  const h = Math.floor(mins / 60);
  const m = mins % 60;
  if (h === 0) return `${m}m`;
  if (m === 0) return `${h}h`;
  return `${h}h ${m}m`;
}

export function snapMinutes(mins, snap = SNAP) {
  return Math.round(mins / snap) * snap;
}

export function todayStr() {
  return dateToStr(new Date());
}

export function dateToStr(d) {
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

export function strToDate(s) {
  const [y, m, d] = s.split("-").map(Number);
  return new Date(y, m - 1, d);
}

export function nowMinutes() {
  const n = new Date();
  return n.getHours() * 60 + n.getMinutes();
}

const DOW = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"];

// Expand recurring events into concrete instances for a given target date string.
export function eventsForDate(events, dateStr) {
  const target = strToDate(dateStr);
  const result = [];
  for (const ev of events) {
    if (ev.date === dateStr) { result.push(ev); continue; }
    if (!ev.recurrence || ev.recurrence === "none") continue;
    const base = strToDate(ev.date);
    if (target < base) continue;
    let match = false;
    if (ev.recurrence === "daily") match = true;
    else if (ev.recurrence === "weekly") match = target.getDay() === base.getDay();
    else if (ev.recurrence === "weekdays") match = target.getDay() >= 1 && target.getDay() <= 5;
    else if (ev.recurrence === "monthly") match = target.getDate() === base.getDate();else if (ev.recurrence === "weekends") match = target.getDay() === 0 || target.getDay() === 6;else if (ev.recurrence === "custom") match = Array.isArray(ev.recurrence_days) && ev.recurrence_days.includes(target.getDay());
    if (match) result.push({ ...ev, date: dateStr, _recurringFrom: ev.id, id: `${ev.id}__${dateStr}` });
  }
  return result.sort((a, b) => a.start_minutes - b.start_minutes);
}

export function realEventId(id) {
  return id.includes("__") ? id.split("__")[0] : id;
}
